import { Injector, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { filter, switchMap, take } from 'rxjs';
import { AuthService } from '../Services/auth.service';
import { DeviceSupportService } from '../Services/device-support.service';
import { initializeApp } from './initialize-app.factory';

export function initializeAppWhenSupported() {
  if (inject(DeviceSupportService).blocked()) {
    return;
  }
  return initializeApp();
}

export function startNavigationWhenSupported(): () => void {
  const router = inject(Router);
  const auth = inject(AuthService);
  const device = inject(DeviceSupportService);
  const injector = inject(Injector);

  return () => {
    if (!device.blocked()) {
      router.initialNavigation();
      return;
    }

    toObservable(device.blocked, { injector })
      .pipe(
        filter((blocked) => !blocked),
        take(1),
        switchMap(() => auth.initializeAuth()),
      )
      .subscribe(() => router.initialNavigation());
  };
}
